export default from './pagination-regular';



// WEBPACK FOOTER //
// ./app/components/pagination-regular/index.js